import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import CaseExplorer from "./components/CaseExplorer";
import TruthTimeline from "./components/TruthTimeline";
import PendingCases from "./components/PendingCases";
import ProcessSteps from "./components/ProcessSteps";
import About from "./components/About";
import Faq from "./components/Faq";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <CaseExplorer />
        <TruthTimeline />
        <PendingCases />
        <ProcessSteps />
        <About />
        <Faq />
        <ContactForm />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}